export const calculateDays = (startDate: string | Date, endDate: string | Date): number => {
    if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        // Reset time to avoid timezone issues
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const timeDiff = end.getTime() - start.getTime();
        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

        return daysDiff + 1; // +1 to include both start and end dates
    }
    return 0;
}; 